import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const {
  INPUT,
  DATE,
  SELECT,
  TEXT_AREA,
  TIME,
  NUMBER,
  CURRENCY,
  COMBO_BOX,
  AUTO_COMPLETE,
} = FIELD_TYPE;

const cssProps = {
  labelCol: { xs: 4, sm: 10, md: 5, xl: 2 },
  wrapperCol: { xs: 22, sm: 24, md: 24, xl: 22 },
  css: { xs: 24, xl: 24, md: 24, sm: 24 },
};

const patientInfo: DataFormField[] = [
  {
    name: "soDienThoai",
    disable: true,
    type: INPUT,
    label: "Số điện thoại",
  },
  {
    name: "diaChi",
    disable: true,
    type: INPUT,
    label: "Địa chỉ",
  },
  {
    name: "thanNhan",
    disable: true,
    type: INPUT,
    label: "Thân nhân",
  },
  {
    name: "bacSiDieuTri",
    disable: true,
    type: INPUT,
    label: "BS chỉ định",
  },
  {
    name: "ngayChiDinh",
    disable: true,
    type: DATE,
    label: "TG chỉ định",
    optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
  },
  {
    name: "dichVu",
    disable: true,
    type: TEXT_AREA,

    label: "Chỉ định",
  },
  {
    name: "tenBacSiDieuTri",
    disable: true,
    type: INPUT,
    label: "BS điều trị",
  },
  {
    name: "chanDoan",
    disable: true,
    type: TEXT_AREA,
    label: "Chẩn đoán",
  },
];

const residentialInfo: DataFormField[] = [
  {
    name: "ddt",
    disable: true,
    type: INPUT,
    label: "Đợt điều trị",
  },
  {
    name: "tienTamUng",
    disable: true,
    type: CURRENCY,
    label: "Tiền tạm ứng",
  },
  {
    name: "tienConLai",
    disable: true,
    type: CURRENCY,
    label: "Tiền còn lại",
  },
  {
    name: "mach",
    disable: true,
    type: INPUT,
    label: "Mạch",
    suffix: "lần/phút",
  },
  {
    name: "nhipTho",
    disable: true,
    type: INPUT,
    label: "Nhịp thở",
    suffix: "lần/phút",
  },
  {
    name: "chieuCao",
    disable: true,
    type: INPUT,
    label: "Chiều cao",
    suffix: "cm",
  },
  {
    name: "nhietDo",
    disable: true,
    type: INPUT,
    label: "Nhiệt độ",
    suffix: "°C",
  },
  {
    name: "huyetAp",
    disable: true,
    type: INPUT,
    label: "Huyết Áp",
    suffix: "mmHg",
  },
  {
    label: "Cân nặng",
    type: INPUT,
    name: "canNang",
    disable: true,
    suffix: "kg",
  },
  {
    label: "Chỉ số BMI",
    type: INPUT,
    name: "chiSoBmi",
    disable: true,
  },
  {
    name: "ngayLapPhieu",
    disable: true,
    type: DATE,
    optionsTime: { showTime: false, format: FORMAT_TIME.dayFull },
    label: "Ngày lập phiếu",
  },
  {
    name: "so",
    disable: true,
    type: NUMBER,
    label: "Số",
  },
  {
    name: "giuongDieuTri",
    disable: true,
    type: INPUT,
    label: "Giường ĐT",
  },
  {
    name: "tongTienDieuTri",
    disable: true,
    type: CURRENCY,
    label: "Tổng tiền điều trị",
  },
  {
    name: "idGiuongBenh",
    disable: true,
    type: INPUT,

    label: "Giường bệnh",
  },
  {
    name: "idGiuongSo",
    disable: true,
    type: INPUT,
    label: "Giường số",
  },
];

const dataAnamnesis: DataFormField[] = [
  {
    name: "tienSuBenhBanThan",
    disable: true,
    type: INPUT,
    label: "Bản thân",
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
  },
  {
    name: "tienSuBenhGiaDinh",
    disable: true,
    type: INPUT,
    label: "Gia đình",
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
  },
];

const dataInfoHospitalise = (form, icdList) => {
  let icdOptions = icdList.map((it) => ({ value: it.maIcd, key: it.id }));
  let tenIcdOptions = icdList.map((it) => ({ value: it.tenIcd, key: it.id }));
  const onKDTSelect = (value, option) => {
    let tmp = icdList.find((it) => it.id === option.key)?.tenIcd;
    form.setFieldValue("chanDoan", tmp);
  };
  const on_KDTSelect = (value, option) => {
    let tmp = icdList.find((it) => it.id === option.key)?.maIcd;
    form.setFieldValue("icdChanDoan", tmp);
  };
  const fields: any = [
    {
      name: "nhipTho",
      disable: true,
      type: INPUT,
      label: "Nhịp thở",
      suffix: "lần/phút",
    },
    {
      name: "mach",
      disable: true,
      type: INPUT,
      label: "Mạch",
      suffix: "lần/phút",
    },
    {
      name: "huyetAp",
      disable: true,
      type: INPUT,
      label: "Huyết áp",
      suffix: "mmHG",
    },
    {
      name: "canNang",
      disable: true,
      type: INPUT,
      label: "Cân nặng",
      suffix: "kg",
    },
    {
      name: "chieuCao",
      disable: true,
      type: INPUT,
      label: "Chiều cao",
      suffix: "cm",
    },
    {
      name: "bmi",
      disable: true,
      type: INPUT,
      label: "BMI",
    },
    {
      name: "nhietDo",
      disable: true,
      type: INPUT,
      label: "Nhiệt độ",
      suffix: "°C",
    },
    {
      name: "spo2",
      disable: true,
      type: INPUT,
      label: "SPO2",
      suffix: "%",
    },
    {
      name: "ghiChu",
      disable: true,
      type: INPUT,
      label: "Ghi chú",
    },
    {
      name: "icdChanDoan",
      disable: true,
      type: AUTO_COMPLETE,
      label: "Mã ICD",
      options: icdOptions,
      onSelect: onKDTSelect,
      filterOption: (inputValue, option) =>
        option!.value
          ?.toString()
          .toUpperCase()
          .indexOf(inputValue.toUpperCase()) !== -1,
    },
    {
      name: "chanDoan",
      disable: true,
      type: AUTO_COMPLETE,
      css: { xl: 16, md: 24 },
      wrapperCol: { xl: 24 },
      onSelect: on_KDTSelect,
      options: tenIcdOptions,
      filterOption: (inputValue, option) =>
        option!.value
          ?.toString()
          .toUpperCase()
          .indexOf(inputValue.toUpperCase()) !== -1,
    },
    {
      name: "chanDoanNoiGioiThieu",
      disable: true,
      type: INPUT,
      label: "Chẩn đoán nơi giới thiệu",
      css: cssProps.css,
      labelCol: cssProps.labelCol,
      wrapperCol: cssProps.wrapperCol,
    },
    {
      name: "lyDoVaoVien",
      disable: true,
      type: INPUT,
      label: "Lý do vào viện",
      css: cssProps.css,
      labelCol: cssProps.labelCol,
      wrapperCol: cssProps.wrapperCol,
    },
    {
      name: "benhSu",
      disable: true,
      type: INPUT,
      label: "Quá trình bệnh lý",
      css: cssProps.css,
      labelCol: cssProps.labelCol,
      wrapperCol: cssProps.wrapperCol,
    },
  ];
  return fields;
};

const dataExamine: DataFormField[] = [
  {
    name: "khamXetToanThan",
    disable: true,
    type: INPUT,
    label: "Toàn thân",
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
  },
  {
    name: "benhChuyenKhoa",
    disable: true,
    type: TEXT_AREA,
    label: "Các bộ phận",
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
  },
  {
    name: "khamXetChanDoanVaoVien",
    disable: true,
    type: INPUT,
    label: "Chẩn đoán vào viện",
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
  },
  {
    name: "daXuLy",
    disable: true,
    type: INPUT,
    label: "Đã xử lý (thuốc...)",
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
  },
];
const css = {
  labelCol: { xl: 4, lg: 10, md: 5, sm: 10 },
  wrapperCol: { xl: 20, lg: 14, md: 19, sm: 14 },
  css: { xl: 12, lg: 12, md: 24, sm: 24 },
};
const thiLucKhongKinh = [
  {
    name: "thiLucKhongKinhMatPhai",
    disable: true,
    type: TEXT_AREA,
    label: "Mắt phải",
    ...css,
  },
  {
    name: "thiLucKhongKinhMatTrai",
    disable: true,
    type: TEXT_AREA,
    label: "Mắt trái",
    ...css,
  },
];

const thiLucCoKinh = [
  {
    name: "thiLucCoKinhMatPhai",
    disable: true,
    type: TEXT_AREA,
    label: "Mắt phải",
    ...css,
  },
  {
    name: "thiLucCoKinhMatTrai",
    disable: true,
    type: TEXT_AREA,
    label: "Mắt trái",
    ...css,
  },
];

const khamMat = [
  {
    name: "khamMatMatPhai",
    disable: true,
    type: TEXT_AREA,
    label: "Mắt phải",
    ...css,
  },
  {
    name: "khamMatMatTrai",
    disable: true,
    type: TEXT_AREA,
    label: "Mắt trái",
    ...css,
  },
];

const nhanAp = [
  {
    name: "nhanApMatPhai",
    disable: true,
    type: TEXT_AREA,
    label: "Mắt phải",
    css: { xl: 12 },
    labelCol: { xl: 4 },
    wrapperCol: { xl: 20 },
  },
  {
    name: "nhanApMatTrai",
    disable: true,
    type: TEXT_AREA,
    label: "Mắt trái",
    css: { xl: 12 },
    labelCol: { xl: 4 },
    wrapperCol: { xl: 20 },
  },
];
export {
  patientInfo,
  residentialInfo,
  dataInfoHospitalise,
  dataAnamnesis,
  dataExamine,
  thiLucKhongKinh,
  thiLucCoKinh,
  khamMat,
  nhanAp,
};
